import React from "react";
// import Gstr1 from "./views/GSTR/Gstr1";
import BalanceSheet from "./views/tree-table/BalanceSheet";


const Toaster = React.lazy(() =>
  import("./views/notifications/toaster/Toaster")
);
const Tables = React.lazy(() => import("./views/base/tables/Tables"));

const Breadcrumbs = React.lazy(() =>
  import("./views/base/breadcrumbs/Breadcrumbs")
);
const Cards = React.lazy(() => import("./views/base/cards/Cards"));
const Carousels = React.lazy(() => import("./views/base/carousels/Carousels"));
const Collapses = React.lazy(() => import("./views/base/collapses/Collapses"));
const BasicForms = React.lazy(() => import("./views/base/forms/BasicForms"));

const Password = React.lazy(() => import("./views/pages/forget-password/Password"));


const Jumbotrons = React.lazy(() =>
  import("./views/base/jumbotrons/Jumbotrons")
);
const ListGroups = React.lazy(() =>
  import("./views/base/list-groups/ListGroups")
);
const Navbars = React.lazy(() => import("./views/base/navbars/Navbars"));
const Navs = React.lazy(() => import("./views/base/navs/Navs"));
const Paginations = React.lazy(() =>
  import("./views/base/paginations/Pagnations")
);
const Popovers = React.lazy(() => import("./views/base/popovers/Popovers"));
const ProgressBar = React.lazy(() =>
  import("./views/base/progress-bar/ProgressBar")
);
const Switches = React.lazy(() => import("./views/base/switches/Switches"));

const Tabs = React.lazy(() => import("./views/base/tabs/Tabs"));
const Tooltips = React.lazy(() => import("./views/base/tooltips/Tooltips"));
const BrandButtons = React.lazy(() =>
  import("./views/buttons/brand-buttons/BrandButtons")
);
const ButtonDropdowns = React.lazy(() =>
  import("./views/buttons/button-dropdowns/ButtonDropdowns")
);
const ButtonGroups = React.lazy(() =>
  import("./views/buttons/button-groups/ButtonGroups")
);
const Buttons = React.lazy(() => import("./views/buttons/buttons/Buttons"));
const Charts = React.lazy(() => import("./views/charts/Charts"));
const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));
const Gstr1 = React.lazy(() => import("./views/GSTR/Gstr1"));
const Gstr3b = React.lazy(() => import("./views/GSTR/Gstr3b"));
const Gstr2b = React.lazy(() => import("./views/Gstr2b"));
const Gstr2a = React.lazy(() => import("./views/gstr2a"));
//new Purchase Register
const NewPurchaseRegister = React.lazy(() => import("./views/Gstr2aPurchase/index.js"));

//new Reconciliation
const NewReconciliation = React.lazy(() => import("./views/Gstr2aReconciliation/NewReconciliaton.js"));

//  empty component as of now to hide gstr2b
const EmptyMsg = React.lazy(() => import("./views/Gstr2b/EmptyMsg.js"));

const Authentication = React.lazy(() => import("./views/User-Authentication/Authentication.js"));
const ConnectPurchaseRegister = React.lazy(() => import("./views/User-Authentication/ConnectPurchaseRegister.js"));
const SubscriptionsPlan = React.lazy(() => import("./views/subscription-plan/SubscriptionsPlan.js"));

const InviteUser = React.lazy(() => import("./views/User-Authentication/InviteUser.js"));

const ReportsGst = React.lazy(() => import("./views/reports/Reports.js"));
const CoreUIIcons = React.lazy(() =>
  import("./views/icons/coreui-icons/CoreUIIcons")
);
//report-header matched


const AllReport = React.lazy(() => import("./views/report-header/all-reports/AllReport.js"));
const Matched = React.lazy(() => import("./views/report-header/matched/Matched.js"));
const MissMatch = React.lazy(() => import("./views/report-header/missmatch/MissMatch"));
const MissingIn2A = React.lazy(() => import("./views/report-header/missing-In-2A/MissingIn2A"));
const MissingIn2B = React.lazy(() => import("./views/report-header/missing-In-2B/MissingIn2B.js"));
const MissingInBooks = React.lazy(() => import("./views/report-header/missing-In-Books/MissingInBooks"));
const ProbableMatch = React.lazy(() => import("./views/report-header/probable-Match/ProbableMatch"));

const ManualMatch = React.lazy(() => import("src/views/report-header/manual-match/ManualMatch.js"));



//supplier
const Supplier = React.lazy(() => import("./views/supplier-header/Supplier"));


const Flags = React.lazy(() => import("./views/icons/flags/Flags"));
const Brands = React.lazy(() => import("./views/icons/brands/Brands"));
const Alerts = React.lazy(() => import("./views/notifications/alerts/Alerts"));
const Badges = React.lazy(() => import("./views/notifications/badges/Badges"));
const Modals = React.lazy(() => import("./views/notifications/modals/Modals"));
const Colors = React.lazy(() => import("./views/theme/colors/Colors"));
const Typography = React.lazy(() =>
  import("./views/theme/typography/Typography")
);
const Widgets = React.lazy(() => import("./views/widgets/Widgets"));
const Users = React.lazy(() => import("./views/users/Users"));
const User = React.lazy(() => import("./views/users/User"));
const Search = React.lazy(() => import("./views/search/Search"));
const TreeTable = React.lazy(() => import("./views/tree-table/TreeTable"));
const LedgersGroupsRelationsTreeTable = React.lazy(() =>
  import(
    "./views/pages/ledgers-groups-relational-tree-table/LedgerGroupsRelationalTreeTable"
  )
);
const TransactionsList = React.lazy(() =>
  import("./views/transactions/transactions-list/TransactionsList")
);
const CustomSearch = React.lazy(() =>
  import("./views/custom-search/CustomSearch")
);
const VoucherView = React.lazy(() =>
  import("./views/transactions/voucher-view/VoucherView")
);
const SingleEntryPaymentView = React.lazy(() =>
  import("./views/transactions/payment-view/PaymentView")
);
const DoubleEntryPaymentView = React.lazy(() =>
  import("./views/transactions/payment-view/PaymentViewDoubleEntry")
);
const LedgersList = React.lazy(() => import("./views/ledgers/Ledgers"));
const LedgerView = React.lazy(() =>
  import("./views/ledgers/ledger-view/LedgerView")
);
const CommonSearch = React.lazy(() =>
  import("./views/pages/common-search/CommonSearch")
);

const PaymentsView = React.lazy(() =>
  import("./views/transactions/payments/PaymentsView")
);

const CreatePayment = React.lazy(() =>
  import("./views/transactions/create-payments/CreatePayment")
);

const CashPayments = React.lazy(() =>
  import("./views/transactions/cash-payments/CashPayments")
);
const CreatePurchase = React.lazy(() =>
  import("./views/transactions/create-purchase/CreatePurchase")
);

const CreateJournal = React.lazy(() =>
  import("./views/pages/journal/CreateJournal")
);

const JournalView = React.lazy(() =>
  import("./views/pages/journal-view/JournalView")
);
const CreateSales = React.lazy(() =>
  import("./views/transactions/create-sales/CreateSales")
);
const PaymentView = React.lazy(() =>
  import("./views/transactions/payment-view/PaymentView")
);
const RecieptView = React.lazy(() =>
  import("./views/transactions/reciept-view/RecieptView")
);
const DRecieptView = React.lazy(() =>
  import("./views/transactions/reciept-view/ReceiptViewDoubleEntry")
);
const PurchaseView = React.lazy(() =>
  import("./views/transactions/purchase-view/PurchaseView")
);
const PurchaseViewAsVoucher = React.lazy(() =>
  import("./views/transactions/purchase-view/PurchaseViewAsInvoice")
);
const SalesView = React.lazy(() =>
  import("./views/transactions/sales-view/SalesView")
);
const SalesViewAsVoucher = React.lazy(() =>
  import("./views/transactions/sales-view/SalesViewAsVoucher")
);
const PurchaseWithInventory = React.lazy(() =>
  import("./views/transactions/purchse-inventory/PurchaseWithInventory")
);
const BalanceTree = React.lazy(() => import("./views/tree-table/BalanceSheet"));
const ProfitAndLoss = React.lazy(() =>
  import("./views/tree-table/ProfitAndLoss")
);
const BillReceivables = React.lazy(() =>
  import("./views/tree-table/BillReceivables")
);
const BillPaybles = React.lazy(() =>
  import("./views/tree-table/BillPayableRecievable")
);
const Groups = React.lazy(() => import("./views/base/tables/Groups"));
const GroupInfo = React.lazy(() =>
  import("./views/base/tables/group-info/GroupInfo")
);
const SearchQuestions = React.lazy(() =>
  import("./views/pages/search-questions/SearchQuestions")
);
const DocumentSearch = React.lazy(() =>
  import("./views/pages/document-search/DocumentSearch")
);
const QueryGroup = React.lazy(() =>
  import("./views/queries/queries-group-list/QueriesGroupList")
);

const QueryList = React.lazy(() =>
  import("./views/queries/quries-list/QueriesList")
);
const OrganisationRegistration = React.lazy(() =>
  import("./views/pages/organisation-registration/OrgRegistration")
);
const OrgCompanyInfo = React.lazy(() =>
  import("./views/pages/organisation-registration/OrgCompanyInfo")
);
const ProfileSetting = React.lazy(() =>
  import("./views/pages/profile/ProfileSetting")
);
const UserTwoFactorAuth = React.lazy(() =>
  import("./views/pages/profile/UserTwoFactorAuth")
);
const SalesRegister = React.lazy(() =>
  import("./views/pages/layouts/sales-register/SalesRegister")
);

const PurchaseRegister = React.lazy(() =>
  import("./views/pages/expenses/purchase-register/PurchaseRegister")
);

const Expenses = React.lazy(() =>
  import("./views/pages/expenses/expenses/Expenses")
);
const SalesOrder = React.lazy(() =>
  import("./views/pages/sales-order/SalesOrder")
);
const SalesOrderView = React.lazy(() =>
  import("./views/pages/sales-order/SalesOrderView")
);
const SalesOrderList = React.lazy(() =>
  import("./views/pages/sales-order/SalesOrderList")
);
const Reports = React.lazy(() =>
  import("./views/pages/reports/Reports")
);
const Registration = React.lazy(() =>
  import("./views/pages/register/Register")
);
const Feed = React.lazy(() =>
  import("./views/pages/feed/Feed")
);
const Inventory = React.lazy(() =>
  import("./views/pages/Inventory/inventory")
);
const InventoryView = React.lazy(() =>
  import("./views/pages/Inventory/InventoryView")
);
// const NoCompanies = React.lazy(() =>
//   import("./views/no-tally-companies/NoCompanies")
// );

const CreateGroup = React.lazy(() =>
  import("./views/pages/create-group/createGroup")
);

const GropExpenseChart = React.lazy(() =>
  import("./views/pages/charts/group-chart/GroupChartsForExpense")
);
const ProfitAndLossChart = React.lazy(() =>
  import("./views/pages/charts/profit-and-loss/ProfitAndLossChart")
);
const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/password", name: "Password", component: Password },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/gstr-1", name: "Gstr", component: Gstr1 },
  { path: "/authentication", name: "Authentication", component: Authentication },
  { path: "/connect-purchase-register", name: "ConnectPurchaseRegister", component: ConnectPurchaseRegister },
  { path: "/subscription-plan", name: "Subscription Plan", component: SubscriptionsPlan },
  { path: "/invite-user", name: "Invite User", component: InviteUser },
  { path: "/reports", name: "ReportsGst", component: ReportsGst },
  { path: "/gstr-3b", name: "Gstr3b", component: Gstr3b },
  { path: "/gstr-2b", name: "Gstr2b", component: Gstr2b },
  { path: "/gstr-2a", name: "Gstr2a", component: Gstr2a },

  //report matched
  { path: "/all-report", name: "Matched", component: AllReport },
  { path: "/matched-report", name: "Matched", component: Matched },
  { path: "/misMatch-report", name: "MissMatch", component: MissMatch },
  { path: "/MissingIn2A-report", name: "MissingIn2A", component: MissingIn2A },
  { path: "/MissingIn2B-report", name: "MissingIn2B", component: MissingIn2B },

  { path: "/MissingInBooks-report", name: "MissingInBooks", component: MissingInBooks },
  { path: "/ProbableMatch-report", name: "ProbableMatch", component: ProbableMatch },

  { path: "/ManualMatch-report", name: "ManualMatch", component: ManualMatch },


  // header supplier
  { path: "/supplier", name: "Supplier", component: Supplier },


  //new purchase register
  { path: "/new-purchase-register", name: "New Purchase Register", component: NewPurchaseRegister },

  //new Reconciliation
  { path: "/new-reconciliation", name: "New Reconciliaton", component: NewReconciliation },

  // empty component as of now to hide gstr2b
  { path: "/NA", name: "NA", component: EmptyMsg },

  { path: "/search", name: "Search", component: Search },
  { path: "/sales-register", name: "Sales Register", component: SalesRegister },
  {
    path: "/purchase-register",
    name: "Purchase Register",
    component: PurchaseRegister,
  },
  {
    path: "/create-group",
    name: "Create Group",
    component: CreateGroup,
  },
  {
    path: "/expenses",
    name: "Expenses",
    component: Expenses,
  },
  { path: "/transactions", name: "Transactions", component: TransactionsList },

  // { path: "/voucher-view", name: "Voucher View", component: VoucherView },
  { path: "/s-voucher-view", name: "Voucher View", component: VoucherView },
  { path: "/d-payment-view", name: "Voucher View", component: DoubleEntryPaymentView },
  { path: "/tree-table", name: "TreeTable", component: TreeTable },
  { path: "/common-search", name: "Common Search", component: CommonSearch },
  { path: "/reports/balance-sheet", name: "Balance Sheet", component: BalanceSheet },
  { path: "/reports/profit-loss", name: "Profit and Loss", component: ProfitAndLoss },
  { path: "/groups", name: "Groups", component: Groups },
  { path: "/group-info", name: "Group Info", component: GroupInfo },
  {
    path: "/ledgers-groups-relational-table",
    name: "Ledgers Groups Relational Table",
    component: LedgersGroupsRelationsTreeTable,
  },
  {
    path: "/payments-view",
    name: "Payments View",
    component: PaymentsView,
  },
  {
    path: "/d-payments-view",
    name: "Payments View",
    component: DoubleEntryPaymentView,
  },
  {
    path: "/ledgers",
    name: "Ledgers",
    component: LedgersList,
  },
  {
    path: "/reports/bill-payables",
    name: "Bill Payables",
    component: BillPaybles,
  },

  {
    path: "/reports/bill-receivables",
    name: "Bill Receivables",
    component: BillReceivables,
  },
  {
    path: "/ledger-view",
    name: "Ledger View",
    component: LedgerView,
  },
  {
    path: "/review-board",
    name: "Review Board",
    component: QueryGroup,
  },
  {
    path: "/feed",
    name: "Feed",
    component: Feed,
  },
  {
    path: "/queries-list",
    name: "Queries List",
    component: QueryList,
  },
  {
    path: "/search-questions",
    name: "Search Questions",
    component: SearchQuestions,
  },
  // {
  //   path: "/no-companies-found",
  //   name: "No Companies Found",
  //   component: NoCompanies,
  // },
  {
    path: "/document-search",
    name: "Document Search",
    component: DocumentSearch,
  },
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
  },
  {
    path: "/tally-registration",
    name: "Tally Companies Registration",
    component: OrganisationRegistration,
  },
  {
    path: "/my-tally-companies",
    name: "My Tally Companies",
    component: OrgCompanyInfo,
  },
  {
    path: "/profile-settings",
    name: "Profile Setting",
    component: ProfileSetting,
  },
  {
    path: "/user-two-factor-auth",
    name: "User Two Factor Auth",
    component: UserTwoFactorAuth,
  },
  {
    path: "/inventory",
    name: "Inventory",
    component: Inventory,
  },
  {
    path: "/inventory-view",
    name: "Inventory View",
    component: InventoryView,
  },
  {
    path: "/purchase-inventory-view",
    name: "Purchase Inventory View",
    component: PurchaseWithInventory,
  },
  {
    path: "/create-payment",
    name: "Create Payment",
    component: CreatePayment,
  },
  {
    path: "/cash-payment",
    name: "Cash Payment",
    component: CashPayments,
  },
  {
    path: "/create-purchase",
    name: "Create Purchase",
    component: CreatePurchase,
  },
  {
    path: "/create-journal",
    name: "Create Journal",
    component: CreateJournal,
  },
  {
    path: "/sales-order",
    name: "Sales Order",
    component: SalesOrder,
  },
  {
    path: "/sales-order-view",
    name: "Sales Order View",
    component: SalesOrderView,
  },
  {
    path: "/sales-order-list",
    name: "Sales Order List",
    component: SalesOrderList,
  },
  {
    path: "/journal-view",
    name: "Journal View",
    component: JournalView,
  },
  {
    path: "/create-sales",
    name: "Create Sales",
    component: CreatePurchase,
  },
  {
    path: "/payment-view",
    name: "Payment View",
    component: PaymentView,
  },
  {
    path: "/receipt-view",
    name: "Receipt View",
    component: RecieptView,
  },
  {
    path: "/d-receipt-view",
    name: "Receipt View",
    component: DRecieptView,
  },
  // {
  //   path: "/reciept-view",
  //   name: "Reciept View",
  //   component: RecieptView,
  // },
  {
    path: "/purchase-view",
    name: "Purchase View",
    component: PurchaseView,
  },
  {
    path: "/i-purchase-view",
    name: "Purchase View",
    component: PurchaseViewAsVoucher,
  },
  {
    path: "/sales-view",
    name: "Sales View",
    component: SalesView,
  },
  {
    path: "/i-sales-view",
    name: "Sales View",
    component: SalesViewAsVoucher,
  },
  {
    path: "/create-receipt",
    name: "Create Receipt",
    component: CreatePayment,
  },
  {
    path: "/group-expense-chart",
    name: "Group Expense Chart",
    component: GropExpenseChart,
  },
  {
    path: "/profit-and-loss",
    name: "Profit And Loss",
    component: ProfitAndLossChart,
  },
  { path: "/theme", name: "Theme", component: Colors, exact: true },
  { path: "/theme/colors", name: "Colors", component: Colors },
  { path: "/theme/typography", name: "Typography", component: Typography },
  { path: "/base", name: "Base", component: Cards, exact: true },
  { path: "/base/breadcrumbs", name: "Breadcrumbs", component: Breadcrumbs },
  { path: "/base/cards", name: "Cards", component: Cards },
  { path: "/base/carousels", name: "Carousel", component: Carousels },
  { path: "/base/collapses", name: "Collapse", component: Collapses },
  { path: "/base/forms", name: "Forms", component: BasicForms },
  { path: "/base/jumbotrons", name: "Jumbotrons", component: Jumbotrons },
  { path: "/base/list-groups", name: "List Groups", component: ListGroups },
  { path: "/base/navbars", name: "Navbars", component: Navbars },
  { path: "/base/navs", name: "Navs", component: Navs },
  { path: "/base/paginations", name: "Paginations", component: Paginations },
  { path: "/base/popovers", name: "Popovers", component: Popovers },
  { path: "/base/progress-bar", name: "Progress Bar", component: ProgressBar },
  { path: "/base/switches", name: "Switches", component: Switches },
  { path: "/base/tables", name: "Tables", component: Tables },
  { path: "/base/tabs", name: "Tabs", component: Tabs },
  { path: "/base/tooltips", name: "Tooltips", component: Tooltips },
  { path: "/buttons", name: "Buttons", component: Buttons, exact: true },
  { path: "/buttons/buttons", name: "Buttons", component: Buttons },
  {
    path: "/buttons/button-dropdowns",
    name: "Dropdowns",
    component: ButtonDropdowns,
  },
  {
    path: "/buttons/button-groups",
    name: "Button Groups",
    component: ButtonGroups,
  },
  {
    path: "/buttons/brand-buttons",
    name: "Brand Buttons",
    component: BrandButtons,
  },
  { path: "/charts", name: "Charts", component: Charts },
  { path: "/icons", exact: true, name: "Icons", component: CoreUIIcons },
  { path: "/icons/coreui-icons", name: "CoreUI Icons", component: CoreUIIcons },
  { path: "/icons/flags", name: "Flags", component: Flags },
  { path: "/icons/brands", name: "Brands", component: Brands },
  {
    path: "/notifications",
    name: "Notifications",
    component: Alerts,
    exact: true,
  },
  { path: "/notifications/alerts", name: "Alerts", component: Alerts },
  { path: "/notifications/badges", name: "Badges", component: Badges },
  { path: "/notifications/modals", name: "Modals", component: Modals },
  { path: "/notifications/toaster", name: "Toaster", component: Toaster },
  { path: "/widgets", name: "Widgets", component: Widgets },
  { path: "/users", exact: true, name: "Users", component: Users },
  { path: "/users/:id", exact: true, name: "User Details", component: User },
];

export default routes;
